import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

import Ctas from '../../../Core/Ctas';

export const Heading = styled.h2`
  text-align: ${({ $textAlign }) => $textAlign || 'left'};
  margin-bottom: var(--Number-6, 1.5rem);
  font-size: 2.25rem;
`;

export const Wrapper = styled.div`
  display: grid;
  grid-auto-flow: row;
  row-gap: var(--Number-6, 1.5rem);

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    grid-auto-flow: column;
    grid-template-columns: repeat(2, 1fr [column]);
    column-gap: var(--Number-6, 1.5rem);
    padding: 0.5rem 0;
  }
`;

export const StyledCtas = styled(Ctas)`
  width: 100%;
  &.center {
    margin: 1.5rem auto;
  }
`;
